"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _vuex = require("vuex");
var _BackToTop = _interopRequireDefault(require("@/components/BackToTop"));
var _timeUtil = require("@/utils/time-util");
var _UploadFileUtil = _interopRequireDefault(require("@/views/mixin/UploadFileUtil"));
var _FirebaseStorageUtil = _interopRequireDefault(require("@/views/mixin/FirebaseStorageUtil"));
var _apolloClient = require("@/apollo/apolloClient");
var _recruitmentMutation = require("@/apollo/mutations/recruitment-mutation");
var _recruitmentQuery = require("@/apollo/queries/recruitment-query");
var _auth = require("@/utils/auth");
var _appUtil = require("@/utils/app-util");
var _v = _interopRequireDefault(require("uuid/v4"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import uuidv4 from 'uuid/v4'
var _default = exports.default = {
  components: {
    BackToTop: _BackToTop.default
  },
  mixins: [_UploadFileUtil.default, _FirebaseStorageUtil.default],
  data: function data() {
    return {
      message: [],
      searching: '',
      company_name: '',
      activeCategory: [],
      fileList: [],
      inputMessage: '',
      baackToTopStyle: {
        right: '20px',
        bottom: '260px',
        width: '40px',
        height: '40px',
        'border-radius': '4px',
        'line-height': '45px',
        background: '#e7eaf1'
      },
      roomData: {
        owner: '',
        charge: '',
        category: '',
        charge_avatar: ''
      },
      chatRoom: {}
    };
  },
  computed: _objectSpread(_objectSpread({
    /*
    message() {
      return this.$store.getters.recruitmentMessages
    },
    */
    recruitment: function recruitment() {
      return this.$store.getters.recruitment;
    }
  }, (0, _vuex.mapState)({
    sidebar: function sidebar(state) {
      return state.app.sidebar;
    },
    device: function device(state) {
      return state.app.device;
    },
    currentClient: function currentClient(state) {
      return state.auth.currentClient;
    }
  })), {}, {
    classObj: function classObj() {
      return {
        openSidebar: this.sidebar.opened,
        hideSidebar: !this.sidebar.opened,
        mobile: this.device === 'mobile'
      };
    }
  }),
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this = this;
      var res, _t;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (this.$route.params.id) {
              (0, _auth.setRecruitmentMessageID)(this.$route.params.id);
            }
            // await this.$store.dispatch('recruitment/fetchRecruitmentMessages', getRecruitmentMessageID())
            _context.next = 1;
            return this.$store.dispatch('recruitment/fetchRecruitmentID', (0, _auth.getRecruitmentMessageID)());
          case 1:
            _context.next = 2;
            return _apolloClient.apolloClient.query({
              query: _recruitmentQuery.RECRUITMENT_MESSAGES,
              variables: {
                id: (0, _auth.getRecruitmentMessageID)()
              }
            });
          case 2:
            res = _context.sent;
            this.$data.message = res.data.recruitment_message;
            this.$nextTick(function () {
              var container = _this.$el.querySelector('#vscr');
              container.scrollTop = container.scrollHeight;
            });
            /*
            this.$nextTick(function() {
              var element = document.documentElement
              window.scrollTo({
                top: (element.scrollHeight - element.clientHeight),
                behavior: 'auto'
              })
            })
            */
            _context.next = 3;
            return _apolloClient.apolloClient.watchQuery({
              query: _recruitmentQuery.RECRUITMENT_MESSAGES,
              variables: {
                id: (0, _auth.getRecruitmentMessageID)()
              },
              fetchPolicy: 'no-cache',
              pollInterval: 3000 // ms
            }).subscribe(function (data) {
              _this.$data.message = data.data.recruitment_message;
              _this.$nextTick(function () {
                var container = _this.$el.querySelector('#vscr');
                container.scrollTop = container.scrollHeight;
              });
              /*
              var container = this.$el.querySelector('#vscr')
              if (this.scroll_top !== container.scrollHeight) {
                container.scrollTop = container.scrollHeight
                this.scroll_top = container.scrollHeight
              }
              */
              /*
              this.$nextTick(function() {
                var element = document.documentElement
                window.scrollTo({
                  top: (element.scrollHeight - element.clientHeight),
                  behavior: 'auto'
                })
              })
              */
            });
          case 3:
            _context.next = 4;
            return _apolloClient.apolloClient.mutate({
              mutation: _recruitmentMutation.CLEAR_MESSAGE_READING_FLAG,
              variables: {
                recruitment_id: (0, _auth.getRecruitmentMessageID)()
              }
            }).then(function (res) {
              _apolloClient.apolloClient.resetStore();
            }).catch(function (error) {
              console.log(error);
            });
          case 4:
            _context.next = 5;
            return (0, _appUtil.checkReadingFlag)(true);
          case 5:
            _t = _context.sent;
            if (!(_t === true)) {
              _context.next = 6;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  beforeDestroy: function () {
    var _beforeDestroy = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _t2;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return _apolloClient.apolloClient.queryManager.pollingInfoByQueryId.forEach(function (val, key) {
              _apolloClient.apolloClient.queryManager.stopPollingQuery(key);
            });
          case 1:
            _context2.next = 2;
            return _apolloClient.apolloClient.mutate({
              mutation: _recruitmentMutation.CLEAR_MESSAGE_READING_FLAG,
              variables: {
                recruitment_id: (0, _auth.getRecruitmentMessageID)()
              }
            }).then(function (res) {
              _apolloClient.apolloClient.resetStore();
            }).catch(function (error) {
              console.log(error);
            });
          case 2:
            _context2.next = 3;
            return (0, _appUtil.checkReadingFlag)(false);
          case 3:
            _t2 = _context2.sent;
            if (!(_t2 === true)) {
              _context2.next = 4;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function beforeDestroy() {
      return _beforeDestroy.apply(this, arguments);
    }
    return beforeDestroy;
  }(),
  methods: {
    onBack: function onBack() {
      return this.$router.push({
        name: 'RecruitmentIndex'
      });
    },
    displayExchangeTarget: function displayExchangeTarget(owner, admin) {
      var target = '';
      if (admin) {
        "".concat(admin.name, "\u21C4").concat(owner);
      } else {
        target = "".concat(owner, "\u306E\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0");
      }
      return target;
    },
    displayMsgTime: function displayMsgTime(dateTime) {
      return (0, _timeUtil.displayChatTime)(dateTime);
    },
    goToChatCharge: function goToChatCharge() {
      return this.$router.push({
        name: 'ChatStaffIndex'
      });
    },
    // ファイルを追加した時
    handleFileAdd: function handleFileAdd(file, fileList) {
      this.fileList = fileList;
    },
    // ファイルを削除した時
    handleFileRemove: function handleFileRemove(file, fileList) {
      this.fileList = fileList;
    },
    onSendMessage: function () {
      var _onSendMessage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.inputMessage === '')) {
                _context3.next = 1;
                break;
              }
              this.$notify({
                title: 'エラー',
                message: 'メッセージが入力されていません。',
                type: 'error',
                duration: 5000
              });
              return _context3.abrupt("return");
            case 1:
              _apolloClient.apolloClient.mutate({
                mutation: _recruitmentMutation.ADD_RECRUITMENT_MESSAGE_CLIENT,
                variables: {
                  recruitment_id: (0, _auth.getRecruitmentMessageID)(),
                  user_type: 2,
                  client_id: (0, _auth.getClientID)(),
                  message: this.inputMessage
                }
              }).then(function (res) {
                _apolloClient.apolloClient.resetStore();
                _this2.inputMessage = '';
                var item = res.data.insert_recruitment_message.returning[0];
                _this2.message.push(item);
                var container = _this2.$el.querySelector('#vscr');
                if (_this2.scroll_top !== container.scrollHeight) {
                  container.scrollTop = container.scrollHeight;
                  _this2.scroll_top = container.scrollHeight;
                }
                /*
                this.$nextTick(function() {
                  var element = document.documentElement
                  window.scrollTo({
                    top: (element.scrollHeight - element.clientHeight),
                    behavior: 'auto'
                  })
                })
                */
              }).catch(function (error) {
                console.log(error);
                _this2.$notify({
                  title: '失敗',
                  message: 'メッセージを送信できませんでした。',
                  type: 'error',
                  duration: 5000
                });
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function onSendMessage() {
        return _onSendMessage.apply(this, arguments);
      }
      return onSendMessage;
    }()
  }
};